import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import {
  Add,
  Edit,
} from "@mui/icons-material";

const InformationCardForm = ({
  open,
  onClose,
  card,
  chitalishte,
  onSubmit,
}) => {
  const [formData, setFormData] = useState({
    year: new Date().getFullYear(),
    totalMembersCount: "",
    newMembers: "",
    employeesCount: "",
    subsidiaryCount: "",
    employeesWithHigherEducation: "",
    folkloreFormations: "",
    theatreFormations: "",
    dancingGroups: "",
    vocalGroups: "",
    workshopsClubsArts: "",
    museumCollections: "",
    projectsParticipationLeading: "",
    projectsParticipationPartner: "",
    participationInTrainings: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (card) {
      setFormData({
        year: card.year || new Date().getFullYear(),
        totalMembersCount: card.totalMembersCount || "",
        newMembers: card.newMembers || "",
        employeesCount: card.employeesCount || "",
        subsidiaryCount: card.subsidiaryCount || "",
        employeesWithHigherEducation: card.employeesWithHigherEducation || "",
        folkloreFormations: card.folkloreFormations || "",
        theatreFormations: card.theatreFormations || "",
        dancingGroups: card.dancingGroups || "",
        vocalGroups: card.vocalGroups || "",
        workshopsClubsArts: card.workshopsClubsArts || "",
        museumCollections: card.museumCollections || "",
        projectsParticipationLeading: card.projectsParticipationLeading || "",
        projectsParticipationPartner: card.projectsParticipationPartner || "",
        participationInTrainings: card.participationInTrainings || "",
      });
    } else {
      setFormData({
        year: new Date().getFullYear(),
        totalMembersCount: "",
        newMembers: "",
        employeesCount: "",
        subsidiaryCount: "",
        employeesWithHigherEducation: "",
        folkloreFormations: "",
        theatreFormations: "",
        dancingGroups: "",
        vocalGroups: "",
        workshopsClubsArts: "",
        museumCollections: "",
        projectsParticipationLeading: "",
        projectsParticipationPartner: "",
        participationInTrainings: "",
      });
    }
    setErrors({});
  }, [card, open]);

  const validateForm = () => {
    const newErrors = {};

    if (
      !formData.year ||
      formData.year < 1900 ||
      formData.year > new Date().getFullYear() + 1
    ) {
      newErrors.year = "Невалидна година";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    setFormData((prev) => ({
      ...prev,
      [field]: value === "" ? "" : Number(value) || value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
    >
      <DialogTitle>
        {card
          ? "Редактиране на информационна карта"
          : "Добавяне на информационна карта"}
        {chitalishte && (
          <Typography variant="subtitle2" color="text.secondary">
            за {chitalishte.name} - {chitalishte.town}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Година *"
              value={formData.year}
              onChange={handleChange("year")}
              error={!!errors.year}
              helperText={errors.year}
              inputProps={{ min: 1900, max: new Date().getFullYear() + 1 }}
            />
          </Grid>

          {/* Membership Data */}
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 2, color: "primary.main" }}>
              Членство
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Общ брой членове"
              value={formData.totalMembersCount}
              onChange={handleChange("totalMembersCount")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Нови членове"
              value={formData.newMembers}
              onChange={handleChange("newMembers")}
            />
          </Grid>

          {/* Staff Data */}
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 2, color: "primary.main" }}>
              Персонал
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Брой служители"
              value={formData.employeesCount}
              onChange={handleChange("employeesCount")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Субсидирани бройки"
              value={formData.subsidiaryCount}
              onChange={handleChange("subsidiaryCount")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Служители с висше"
              value={formData.employeesWithHigherEducation}
              onChange={handleChange("employeesWithHigherEducation")}
            />
          </Grid>

          {/* Cultural Activities */}
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 2, color: "primary.main" }}>
              Културни формации
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Фолклорни формации"
              value={formData.folkloreFormations}
              onChange={handleChange("folkloreFormations")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Театрални формации"
              value={formData.theatreFormations}
              onChange={handleChange("theatreFormations")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Танцови групи"
              value={formData.dancingGroups}
              onChange={handleChange("dancingGroups")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Вокални групи"
              value={formData.vocalGroups}
              onChange={handleChange("vocalGroups")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Клубове по изкуства"
              value={formData.workshopsClubsArts}
              onChange={handleChange("workshopsClubsArts")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Музейни колекции"
              value={formData.museumCollections}
              onChange={handleChange("museumCollections")}
            />
          </Grid>

          {/* Projects and Training */}
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mb: 2, color: "primary.main" }}>
              Проекти и обучения
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Самостоятелни проекти"
              value={formData.projectsParticipationLeading}
              onChange={handleChange("projectsParticipationLeading")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Проекти в партньорство"
              value={formData.projectsParticipationPartner}
              onChange={handleChange("projectsParticipationPartner")}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              type="number"
              label="Участия в обучения"
              value={formData.participationInTrainings}
              onChange={handleChange("participationInTrainings")}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отказ</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          startIcon={card ? <Edit /> : <Add />}
        >
          {card ? "Запази" : "Добави"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InformationCardForm;